export default "__VITE_ASSET__BJZFiORI__"